import type {CSSProperties} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import type {AchievementMiniCardProps} from "./types";
import './achievement-mini-card.scss';

export default function AchievementMiniCard({
    title,
    description,
    dateLabel,
    color,
    icon
}: AchievementMiniCardProps) {
    return (
        <article className="achievement-mini-card">
            <div className="achievement-mini-card__badge">
                <div className="achievement-mini-card__hex" style={{'--achievement-color': color} as CSSProperties} aria-hidden="true">
                    <FontAwesomeIcon icon={icon} />
                </div>
            </div>
            <time>{dateLabel}</time>
            <strong>{title}</strong>
            {description ? <p>{description}</p> : null}
        </article>
    );
}
